import styled from 'styled-components';

const Center = styled.div`
  box-sizing: content-box;
  margin-inline: auto;
  max-inline-size: ${props => props.max ?? props.max};
`;

export default Center;
